module.exports = __webpack_public_path__ + "img/arcturus1.dc74b69.png";